import Vue from 'vue';
import VueRouter from 'vue-router';
import admin from './admin';
import bank from './bank';
import report from './report';
import middlewarePipeline, { createMiddlewareContext } from './middlewarePipeline';
import { getAuthorizedRedirect, getUnauthorizedRedirect } from '@/router/access';

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue'),
  },
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue'),
    children: [admin, bank, report],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  console.log(`root from:${from.path} to:${to.path} to.middleware:`);

  // Импортируем store динамически или используем уже созданные
  // Важно: импортируем здесь, а не вверху файла
  const {
    useUserStore,
    useI18nStore,
    useAppStore,
    useBankStore,
    useEnvStore,
    useSoundStore,
    useLoaderStore,
    useColorStore,
    useSystemStore,
  } = await import('@/store/stores');

  const userStore = useUserStore();
  const i18nStore = useI18nStore();
  const appStore = useAppStore();
  const bankStore = useBankStore();
  const envStore = useEnvStore();
  const soundStore = useSoundStore();
  const loaderStore = useLoaderStore();

  if (userStore.authorized === undefined) {
    console.log('auth rule1 setData', undefined);
    try {
      const colorStore = useColorStore();
      await userStore.getUser();

      const actionsStore = [colorStore.getDesignConfig];

      if (userStore.authorized === 'no_authorized') {
        actionsStore.unshift(i18nStore.getI18n);
      }

      await Promise.all(actionsStore.map((action) => action()));
      colorStore.setTheme();

      document.querySelector('title').innerHTML = i18nStore.voc.LKB_TITLE || '';
    } catch (e) {
      console.error(e);
      return next(false);
    }
  }

  if (userStore.authorized === 'authorized') {
    //todo При смене роли и uncaught Exception error;
    const redirect = getAuthorizedRedirect(to, from, userStore);
    if (redirect) {
      return next(redirect);
    }

    console.log('auth rule2, authorized');
    if (!to.meta.middleware || !to.meta.middleware.length) {
      console.log(`root from:${from.path} to:${to.path} to.middleware:`, null);
      return next();
    }
    const middleware = to.meta.middleware;
    // console.log(`root from:${from.path} to:${to.path} to.middleware:`, middleware);

    const context = createMiddlewareContext(to, from, next, {
      appStore,
      userStore,
      i18nStore,
      bankStore,
      envStore,
      soundStore,
      loaderStore,
    });

    return middleware[0]({
      context,
      nextMiddleware: middlewarePipeline(context, middleware, 1),
    });
  } else if (userStore.authorized === 'no_authorized') {
    console.log('auth rule3, no_authorized');
    const redirect = getUnauthorizedRedirect(to);
    return redirect ? next(redirect) : next();
  } else if (userStore.authorized === 'blocked') {
    const systemStore = useSystemStore();
    systemStore.setAccessUser();
  }

  console.log('auth rule4, ACCESS_DENIED', userStore.authorized);
  return next(false);
});

export default router;
